import { MEDALLIA_ICON_DARK_SRC } from '../../visual-elements/application-menu/icons';
export const getMenuHeaderLi = (headerText) => {
    const headlerLI = document.createElement('li');
    headlerLI.classList.add('mas-app-menu-header');
    if (headerText) {
        const headerTextSpan = document.createElement('span');
        headerTextSpan.classList.add('mas-app-menu-header-text');
        headerTextSpan.textContent = headerText;
        headlerLI.appendChild(headerTextSpan);
        return headlerLI;
    }
    // Default use the Medallia Logo in the header
    const logoImg = document.createElement('img');
    logoImg.setAttribute('src', MEDALLIA_ICON_DARK_SRC);
    logoImg.classList.add('mas-app-menu-medallia-logo');
    headlerLI.appendChild(logoImg);
    return headlerLI;
};
